import {FC, useEffect, useRef, useState} from 'react'
import {Link, useSearchParams} from 'react-router-dom'
import {setAuth} from '../core/AuthHelpers'
import {signupExchange} from '../core/_requests'

// Entrada no app logo depois do cadastro (signup.taskrush.com.br). O signup redireciona para
// /auth/entrar?code=..., o código vale uma vez e por 2 minutos, e é trocado aqui pelo token.
// Fica fora do wrapper <App/>, como o ImpersonateCallback: substitui qualquer sessão aberta.
const SignupEntry: FC = () => {
  const [searchParams] = useSearchParams()
  const [failed, setFailed] = useState(false)
  // StrictMode roda o efeito duas vezes em dev; o código só pode ser trocado uma.
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true

    const code = searchParams.get('code')
    if (!code) {
      setFailed(true)
      return
    }

    signupExchange(code)
      .then(({data}) => {
        setAuth(data)
        // Recarrega para iniciar a sessão do zero; sem o código no histórico do navegador.
        window.location.replace(`${process.env.PUBLIC_URL || ''}/dashboard`)
      })
      .catch(() => setFailed(true))
  }, [searchParams])

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column flex-center text-center p-10'>
          <div className='card card-flush w-lg-650px py-5'>
            <div className='card-body py-15 py-lg-20'>
              {!failed ? (
                <>
                  <div className='mb-7'>
                    <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
                  </div>
                  <h1 className='fw-bolder text-gray-900 mb-5'>Abrindo o TaskRush...</h1>
                  <div className='fw-semibold fs-6 text-gray-500'>Sua conta está pronta.</div>
                </>
              ) : (
                <>
                  <div className='mb-7'>
                    <i className='bi bi-box-arrow-in-right text-brand fs-3x'></i>
                  </div>
                  <h1 className='fw-bolder text-gray-900 mb-5'>Sua conta está criada</h1>
                  <div className='fw-semibold fs-6 text-gray-500 mb-8'>
                    Este link de acesso já foi usado ou expirou. Entre com o e-mail e a senha que
                    você cadastrou.
                  </div>
                  <Link to='/auth/login' className='btn btn-primary'>
                    Entrar
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {SignupEntry}
